/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
// 可以优化,不同的角色加载不同的路由 todo
import Vue from 'vue'
import Router from 'vue-router'
import i18n from '@/lang'; // Internationalization
Vue.use(Router)
let vm = new Vue({
  i18n,
})

export const routerArr = [
  {
    path: '/',
    redirect: {
      name: 'dashboard'
    }
  },
  {
    path: '',
    component: () => import('@/layouts/full-page/FullPage.vue'),
    children: [
      {
        path: '/login',
        name: 'login',
        component: () => import('@/views/login/index'),
        meta:{
          title: vm.$t('Log_in'),
        }
      },
    ]
  },

  {
    path: '',
    component: () => import('@/layouts/full-page/FullPage.vue'),
    children: [
      {
        path: '/register',
        name: 'register',
        component: () => import('@/views/register/index.vue'),
        meta:{
          title: vm.$t('register'),
        }
      },
    ]
  },
  {
    path: '',
    component: () => import('@/layouts/full-page/FullPage.vue'),
    children: [
      {
        path: '/simpleRegister',
        name: 'simpleRegister',
        component: () => import('@/views/simpleRegister/index.vue'),
        meta:{
          title: vm.$t('register'),
        }
      },
    ]
  },
  // 激活账号
  {
    path: '/register/checkEmail',
    name: 'checkEmail',
    component: () => import('@/views/register/checkEmail'),
  },
  {
    path: '',
    component: () => import('@/layouts/main/Main.vue'),
    children: [
      {
        path: '/perfectInfo',
        name: 'perfectInfo',
        component: () => import('@/views/perfectInfo/index.vue'),
        meta: {
          title: vm.$t('User.reportImgStatus'),
        },
      },
    ]
  },
  {
    path: '',
    component: () => import('@/layouts/full-page/FullPage.vue'),
    children: [
      {
        path: '/resetPassword',
        name: 'resetPassword',
        component: () => import('@/views/resetPassword.vue'),
        meta: {
          title: vm.$t('Login.forgetPwd'),
        },
      },
    ]
  },
  {
    path: "",
    component: () => import('@/layouts/main/Main.vue'),
    meta: {
      icon: "site", // icon对应的名字
      noCache: false,
      message: '0', // 右边提示的对应的消息多少个
    },
    children: [
      {
        name: "dashboard",
        path: "dashboard",
        component: () => import('@/views/customer/dashboard/index'),
        meta: {
          title: vm.$t('home'),
          icon: "peoples",
          noCache: false
        },
      },
      {
        name: "integralShop",
        path: "integralShop",
        component: () => import('@/views/integralShop/index'),
        meta: {
          title: vm.$t('integral_Shop'),
          icon: "peoples",
          noCache: false
        },
      },
      // 积分明细  integral
      {
        path: 'integral',
        name: 'integral',
        component: () => import('@/views/integral/index'),
        meta:{
          title: vm.$t('Points_Details')
        },
        redirect: {
          name: 'integralHome'
        },
        children:[
          {
            path: '',
            redirect: {
              name: 'integralHome'
            }
          },
          {
            path: 'integralHome',
            name: 'integralHome',
            component: () => import('@/views/integral/integralHome/index'),
            meta: {
              title: vm.$t('Points_Details'),
              noCache: false
            },
          },
          {
            path: 'integralRecord',
            name: 'integralRecord',
            component: () => import('@/views/integral/integralRecord/index'),
            meta: {
              title: vm.$t('Points_record'),
              noCache: false
            },
          }
        ]
      },
      {
        path: 'productDetail/:id',
        name: 'productDetail',
        component: () => import('@/views/integralShop/productDetail'),
        meta:{
          title: vm.$t('product_detail'),
        },
      },
      {
        name: "files",
        path: "files",
        component: () => import('@/views/customer/myFiles/index'),
        meta: {
          title: vm.$t('personal_information'),
          icon: "CircleIcon", // 'CircleIcon'
          noCache: false
        },
        children: [
          {
            name: "personalInformation",
            path: "personalInformation",
            component: () => import('@/views/customer/myFiles/personalInformation/index'),
            meta: {
              title: vm.$t('personal_information'),
              icon: "CircleIcon", // 'CircleIcon'
              noCache: false
            },
          },
          {
            name: "collection",
            path: "collection",
            component: () => import('@/views/customer/myFiles/collection/index'),
            meta: {
              title: vm.$t('Billing_message'),
              icon: "CircleIcon", // 'CircleIcon'
              noCache: false
            },
          },
          {
            name: "securitySettings",
            path: "securitySettings",
            component: () => import('@/views/customer/myFiles/securitySettings/index'),
            meta: {
              title: vm.$t('security_settings'),
              icon: "CircleIcon", // 'CircleIcon'
              noCache: false
            },
          },
        ]
      },

      {
        name: "deposit",
        path: "deposit",
        redirect: {
          name: 'depositFunds'
        },
        component: () => import('@/views/customer/deposit/index'),
        meta: {
          title: vm.$t('Trade.deposit'),
          icon: "peoples",
          noCache: false
        },
        children: [
          {
            name: "depositFunds",
            path: "depositFunds",
            component: () => import('@/views/customer/deposit/home/index'),
            meta: {
              title: vm.$t('Trade.deposit'),
              icon: "peoples",
              noCache: false
            },
          },
          {
            // 本地汇款详情
            path: "onlinePayDetail/:channelCode",
            name: 'onlinePayDetail',
            component: () => import('@/views/customer/deposit/onlinePayDetail/index'),
            meta: {
              title: vm.$t('Trade.deposit'),
              icon: "peoples",
              noCache: false
            },
          },
          {
            // 电汇详情
            path: "telegraphicPayDetail/:channelCode",
            name: 'telegraphicPayDetail',
            component: () => import('@/views/customer/deposit/telegraphicPayDetail/index'),
            meta: {
              title: vm.$t('Trade.deposit'),
              icon: "peoples",
              noCache: false
            },
          },
          {
            // 数字货币详情
            path: "digitalCashPayDetail/:channelCode",
            name: 'digitalCashPayDetail',
            component: () => import('@/views/customer/deposit/digitalCashPayDetail/index'),
            meta: {
              title: vm.$t('Trade.deposit'),
              icon: "peoples",
              noCache: false
            },
          },
          {
            // 公共提交订单页面
            path: "successSubmit",
            name: 'successSubmit',
            component: () => import('@/views/customer/deposit/successSubmit/index'),
            meta: {
              title: vm.$t('Trade.deposit'),
              icon: "peoples",
              noCache: false
            },
          },
        ]
      },
      {
        name: "withdrawModule",
        path: "withdrawModule",
        redirect: {
          name: 'withdraw'
        },
        component: () => import('@/views/customer/withdraw/index'),
        meta: {
          title: vm.$t('Trade.withdraw'),
          icon: "peoples",
          noCache: false
        },
        children: [
          {
            path: "withdraw",
            name: "withdraw",
            component: () => import('@/views/customer/withdraw/home/index'),
            meta: {
              title: vm.$t('Withdraw'),
              icon: "peoples",
              noCache: false
            },
          },
          {
            path: "withdrawDetail/:payTypeId",
            name: "withdrawDetail",
            component: () => import('@/views/customer/withdraw/withdrawDetail/index'),
            meta: {
              title: vm.$t('Withdraw'),
              icon: "peoples",
              noCache: false
            },
          },
          {
            // 公共提交订单页面
            path: "successWithdrawSubmit",
            name: 'successWithdrawSubmit',
            component: () => import('@/views/customer/withdraw/successWithdrawSubmit/index'),
            meta: {
              title: vm.$t('Withdraw'),
              icon: "peoples",
              noCache: false
            },
          },
        ]
      },

      {
        name: "transfers",
        path: "transfers",
        component: () => import('@/views/customer/transfers/index'),
        meta: {
          title: vm.$t('User.transferAccounts'),
          icon: "peoples",
          noCache: false
        },
      },

      {
        name: "fundsList",
        path: "fundsList",
        component: () => import('@/views/customer/fundsList/index'),
        meta: {
          title: vm.$t('funds_list'),
          icon: "peoples",
          noCache: false
        },
      },
      {
        name: "auditList",
        path: "auditList",
        component: () => import('@/views/customer/auditList/index'),
        meta: {
          title: vm.$t('audit_list'),
          icon: "peoples",
          noCache: false
        },
      },

      {
        name: "bonusList",
        path: "bonusList",
        component: () => import('@/views/customer/bonusManage/bonusList/index'),
        meta: {
          title: vm.$t('User.goldManage'),
          icon: "peoples",
          noCache: false
        },
      },
      // 赠金记录的内页面: 已完成手数 todo, 需要传递赠金记录id
      {
        path: "doLot/:id",
        name: "doLot",
        component: () => import('@/views/customer/bonusManage/doLot/index'),
        meta: {
          title: vm.$t('User.goldManage'),
          icon: "peoples",
          noCache: false
        },
      },

      {
        name: "turnList",
        path: "turnList",
        component: () => import('@/views/customer/bonusManage/turnList/index'),
        meta: {
          title: vm.$t('withgold.TransferRecord'),
          icon: "peoples",
          noCache: false
        },
      },

      {
        name: "traderReport",
        path: "traderReport",
        redirect: {
          name: 'positionOrder'
        },
        component: () => import('@/views/customer/traderReport/index'),
        meta: {
          title: vm.$t('trader_Report'),
          icon: "peoples",
          noCache: false
        },
        children: [
          {
            name: "positionOrder",
            path: "positionOrder",
            component: () => import('@/views/customer/traderReport/position/index'),
            meta: {
              title: vm.$t('trader_Report'),
              icon: "peoples",
              noCache: false
            },
          },
          {
            name: "pendingOrder",
            path: "pendingOrder",
            component: () => import('@/views/customer/traderReport/pendingOrder/index'),
            meta: {
              title: vm.$t('trader_Report'),
              icon: "peoples",
              noCache: false
            },
          },
          {
            name: "traderHistory",
            path: "traderHistory",
            component: () => import('@/views/customer/traderReport/traderHistory/index'),
            meta: {
              title: vm.$t('trader_Report'),
              icon: "peoples",
              noCache: false
            },
          },
        ]
      },
      // 匹配app入金的跳转url的第三方页面
      {
        path: 'matchUniDeposit',
        name: 'matchUniDeposit',
        component: () => import('@/views/matchUniDeposit/index'),
        meta: {
          title: vm.$t('Trade.depo'),
        },
      },

      // 需要看下消息页面是否可以共用 todo
      {
        name: "message",
        path: "message",
        redirect: {
          name: 'notice'
        },
        component: () => import('@/views/customer/message/index'),
        meta: {
          title: vm.$t('message'),
          icon: "peoples",
          noCache: false
        },
        children: [
          {
            name: "notice",
            path: "notice",
            component: () => import('@/views/customer/message/notice/index'),
            meta: {
              title: vm.$t('announcement'),
              icon: "peoples",
              noCache: false
            },
          },
          {
            name: "messageSite",
            path: "messageSite",
            component: () => import('@/views/customer/message/messagSite/index'),
            meta: {
              title: vm.$t('announcement'),
              icon: "peoples",
              noCache: false
            },
          }
        ]
      },
      {
        name: "download",
        path: "download",
        component: () => import('@/views/customer/download/index'),
        meta: {
          title: vm.$t('trading_software'),
          icon: "peoples",
          noCache: false
        },
      },
      {
        name: "downloadFiles",
        path: "downloadFiles",
        component: () => import('@/views/customer/downloadFiles/index'),
        meta: {
          title: vm.$t('Files'),
          icon: "peoples",
          noCache: false
        },
      },
      {
        name: "propagandas",
        path: "propagandas",
        component: () => import('@/views/agent/propagandas/index'),
        meta: {
          title: vm.$t('My_promotion'),
          icon: "peoples",
          noCache: false
        },
      },
      //代理 todo
      //我的客户
      {
        name: "report_custom",
        path: "report_custom",
        component: () => import('@/views/agent/myCustomer/report_custom/index'),
        meta: {
          title: vm.$t('Direct_customer_list'),
          icon: "peoples",
          noCache: false
        },
      },
      {
        name: "report_subIb",
        path: "report_subIb",
        component: () => import('@/views/agent/myCustomer/report_subIb/index'),
        meta: {
          title: vm.$t('User.reportSubibList'),
          icon: "peoples",
          noCache: false
        },
      },
      {
        name: "accountList",
        path: "accountList",
        component: () => import('@/views/agent/myCustomer/accountList/index'),
        meta: {
          title: vm.$t('User.accountList'),
          icon: "peoples",
          noCache: false
        },
      },
      //
      {
        name: "agentFundsList",
        path: "agentFundsList",
        component: () => import('@/views/agent/agentFundsList/index'),
        meta: {
          title: vm.$t('funds_list'),
          icon: "peoples",
          noCache: false
        },
      },
      {
        name: "agentTradeHistory",
        path: "agentTradeHistory",
        component: () => import('@/views/agent/agentTradeHistory/index'),
        meta: {
          title: vm.$t('Transaction_history'),
          icon: "peoples",
          noCache: false
        },
      },
      {
        name: "symbolStatistics",
        path: "symbolStatistics",
        component: () => import('@/views/agent/symbolStatistics/index'),
        meta: {
          title: vm.$t('Symbol_Statistics'),
          icon: "peoples",
          noCache: false
        },
      },
      {
        name: "commissionRecord",
        path: "commissionRecord",
        component: () => import('@/views/agent/commissionManage/comissionReord/index'),
        meta: {
          title: vm.$t('menu.Commission_details'),
          icon: "peoples",
          noCache: false
        },
      },
      {
        name: "commissionOutRecord",
        path: "commissionOutRecord",
        component: () => import('@/views/agent/commissionManage/commissionOutRecord/index'),
        meta: {
          title: vm.$t('User.reportCommiRecord'),
          icon: "peoples",
          noCache: false
        },
      },
      {
        name: "performanceStatistics",
        path: "performanceStatistics",
        redirect: {
          name: 'customerPerformanceStatistics'
        },
        component: () => import('@/views/agent/performanceStatistics/index'),
        meta: {
          title: vm.$t('Performance_Statistics'),
          icon: "peoples",
          noCache: false
        },
        children: [
          {
            name: "customerPerformanceStatistics",
            path: "customerPerformanceStatistics",
            component: () => import('@/views/agent/performanceStatistics/customerPerformanceStatistics/index'),
            meta: {
              title: vm.$t('Performance_Statistics'),
              icon: "peoples",
              noCache: false
            },
          },
          {
            name: "subIbPerformanceStatistics",
            path: "subIbPerformanceStatistics",
            component: () => import('@/views/agent/performanceStatistics/subIbPerformanceStatistics/index'),
            meta: {
              title: vm.$t('Performance_Statistics'),
              icon: "peoples",
              noCache: false
            },
          },
        ]
      },
      {
        name: "copyMaster",
        path: "copyMaster",
        component: () => import('@/views/customer/copyMaster/index'),
        meta: {
          title: "Copy Master",
          noCache: false
        },
      },
      {
        path: 'mamMasterDetails/:mtid',
        name: 'mamMasterDetails',
        component: () => import('@/views/mamMasterDetails/index'),
        redirect: {
          name: 'mamMasterOverview'
        },
        children:[
          {
            path: 'mamMasterOverview',
            name: 'mamMasterOverview',
            component: () => import('@/views/mamMasterDetails/overview/index'),
            meta:{
              title: vm.$t('MAM_Account_Details'),
            }
          },
          {
            path: 'mamMasterTradingCycle',
            name: 'mamMasterTradingCycle',
            component: () => import('@/views/mamMasterDetails/mamMasterTradingCycle/index'),
            meta:{
              title: vm.$t('MAM_Account_Details'),
            }
          },
          {
            path: 'mamMasterSubscription',
            name: 'mamMasterSubscription',
            component: () => import('@/views/mamMasterDetails/subscription/index'),
          },

          /*{
            path: 'mamMasterFollowSetting',
            name: 'mamMasterFollowSetting',
            component: () => import('@/views/mamMasterDetails/detailsSetting/mamMasterFollowSetting/index'),
            meta:{
              title: vm.$t('MAM_Account_Details'),
            }
          },*/
          {
            path: 'mamMasterIncome',
            name: 'mamMasterIncome',
            component: () => import('@/views/mamMasterDetails/subscription/mamMasterIncome/index'),
            meta:{
              title: vm.$t('income'),
            }
          },
        ]
      },
      {
        path: 'mamSubDetails/:mtid',
        name: 'mamSubDetails',
        redirect: {
          name: 'mamSubSubscription'
        },
        component: () => import('@/views/mamSubDetails/index'),
        children:[
          {
            path: 'mamSubSubscription',
            name: 'mamSubSubscription',
            component: () => import('@/views/mamSubDetails/subscription/index'),
          },

          {
            path: 'mamSubExpend',
            name: 'mamSubExpend',
            component: () => import('@/views/mamSubDetails/subscription/mamSubExpend/index'),
            meta:{
              title: vm.$t('expenses'),
            }
          },
        ]
      },
      {
        path: 'generalDetails/:mtid',
        name: 'generalDetails',
        component: () => import('@/views/generalDetails/index'),
        meta:{
          // title: vm.$t('General_Account_Details'),
        },
        redirect: {
          name: 'generalOverview'
        },
        children:[
          {
            path: 'generalOverview',
            name: 'generalOverview',
            component: () => import('@/views/generalDetails/overview/index'),
            meta:{
              title: vm.$t('Account_details'),
            },
          },
          {
            path: 'generalFollowSetting',
            name: 'generalFollowSetting',
            component: () => import('@/views/generalDetails/detailsSetting/generalFollowSetting/index'),
            meta:{
              title: vm.$t('Account_details'),
            },
          },
        ]
      },
      {
        name: "faq",
        path: "faq",
        component: () => import('@/views/customer/faq/index'),
        meta: {
          title: 'FAQ',
          icon: "FAQ",
        },
      }
    ]
  },

  /*{
    path: "",
    component: () => import('@/layouts/main/Main.vue'),
      title: "平台管理",
      icon: "site",
      noCache: false
    },
    children: [
      {
        name: "addMerchant",
        path: "addMerchant",
        component: () => import('@/views/platformManager/merchant/merchantList/addMerchant'),
        componentName: "addMerchant",
        meta: {
          title: "添加商户",
          titleEn: "添加商户",
          icon: "peoples",
          noCache: false
        },
      },
    ]
  },*/
 /* {
    path: "",
    component: () => import('@/layouts/main/Main.vue'),
    meta: {
      title: "系统管理",
      titleEn: "system management ",
      icon: "site",
      noCache: false
    },
    children: [
      {
        name: "menu",
        path: "menu",
        component: () => import('@/views/systemManager/menu/index'),
        componentName: "menu",
        meta: {
          title: "菜单管理",
          titleEn: "menu management",
          icon: "peoples",
          noCache: false
        },
      },
    ]
  },*/
];

const router = new Router({
    mode: 'history',
    scrollBehavior () {
        return { x: 0, y: 0 }
    },
    routes: routerArr,
});

router.beforeEach((to, from,next) => {
  document.body.classList.remove('simpleRegister');
  // 而不是去检查每条路由记录
  if(to.meta.title){
    document.title = to.meta.title + ' -  ' + 'Maxain';
  }else {
    document.title = 'Maxain';
  }
  if(to.name == 'dashboard' && !localStorage.getItem('token')){
    next({name: 'login'});
  }
  next();
})
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        appLoading.style.display = "none";
    }
});
export default router
